import 'css-chunksrc/client/scenes/addIdentityProvider/form/formTypeSelect/styles.scss';export default {
  "formTypeSelect": "_formTypeSelect_j2ouf_1",
  "input": "_input_j2ouf_5",
  "name": "_name_j2ouf_16",
  "iconBox": "_iconBox_j2ouf_22",
  "icon": "_icon_j2ouf_22",
  "open": "_open_j2ouf_37",
  "listRoot": "_listRoot_j2ouf_45",
  "list": "_list_j2ouf_45",
  "item": "_item_j2ouf_63"
};